<template>
  <aside class="sidebar has-background-grey-darker has-shadow has-text-white">
    <p class="menu-label">
      <img class="has-padding-vertical has-margin-top" src="https://app.wavve.co/img/logo-light-text.fb54e365.png"
        alt="Wavve Logo" />
    </p>
    <ul class="menu-list">
      <li class="has-padding-top">
        <span class="is-uppercase has-small-margin-left">Support</span>
        <ul>
          <router-link :to="{ name: 'manager' }">Manage Users</router-link>
          <router-link :to="{ name: 'reports' }">View Jobs</router-link>
          <!-- <router-link :to="{ name: 'metrics' }">Metrics</router-link> -->
          <!-- <router-link :to="{ name: 'conference' }">Sharing</router-link> -->
        </ul>
      </li>
      <li></li>
      <li class="has-padding-top">
        <span class="is-uppercase has-small-margin-left">Other...</span>
        <ul>
          <!-- <a v-bind:href="'https://app.intercom.com/admins/sign_in'">
            Intercom
          </a>
          <a v-bind:href="'https://kb.wavve.co'"> Internal KB </a>
          <a v-bind:href="'https://github.com/wavve'"> Github </a>
          <a v-bind:href="'https://openreplay.wavve.co/'"> OpenReplay </a> -->
          <a @click="logout" class="navbar-item">Logout</a>
        </ul>
      </li>
    </ul>
  </aside>
</template>
<script>
import { LOGOUT } from "@/store/action-types";

export default {
  name: "Sidebar",
  data() {
    return {};
  },
  methods: {
    async logout() {
      await this.$store.dispatch(LOGOUT);
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  overflow-x: hidden;
  z-index: 1;
  height: 100vh;
  width: var(--sidebar-width);
  overflow-y: hidden;

  .menu-label {
    text-align: center;

    img {
      width: 80%;
    }
  }

  a {
    color: white;
    transition: all 0.15s;

    &:hover {
      background-color: whitesmoke;
      color: #333;
    }
  }

  .router-link-active {
    background-color: whitesmoke;
    color: #333;
  }

  .social-links {
    text-align: center;
    position: absolute;
    bottom: 1em;
    left: 0;
    right: 0;

    a {
      font-size: 1.25em;
      border-radius: 3px;
      padding: 0 0.5em;
    }
  }
}
</style>
